<template>
  <Box :aspect="0.4" class="map-container mb-15">
    <GMapMap
      :center="mapCenter"
      :zoom="location ? 14 : 10"
      :options="defaultOptions"
      class="h-fit"
      map-type-id="roadmap"
      @click="setGisLocation"
    >
      <GMapMarker
        :position="location && {
          lat: location?.lat,
          lng: location?.long
        }"
      />
    </GMapMap>
  </Box>
</template>

<script lang="ts" setup>
import { useVModel } from '@vueuse/core';
import Box from '@components/utils/Box.vue';
import type { Location } from '@/entities/Entities';
import { syncRef } from '@/hooks/state';
import { defaultCenter, defaultOptions } from '@/utils/map';

interface Props {
  modelValue?: Location;
  disabled?: boolean;
}

const emit = defineEmits(['update:modelValue']);
const props = defineProps<Props>();
const location = useVModel(props, 'modelValue', emit, { passive: true });

const mapCenter = syncRef(location, (loc) =>
  (loc
    ? {
      lat: loc.lat,
      lng: loc.long,
    }
    : defaultCenter));

const setGisLocation = (event: google.maps.MapMouseEvent) => {
  if (event.latLng && !props.disabled) {
    location.value = {
      lat: event.latLng?.lat(),
      long: event.latLng?.lng(),
    };
  }
};
</script>
